import React from "react";

import { IActiveLearningLesson } from "../../../state";
import {
  activeLearningProjectionPath,
  prefixPath,
} from "../../../teacherStore";
import { ReactComponent as ProjectorIcon } from "../../../assets/svg/projector.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/svg/arrow_l.svg";
import { ReactComponent as ArrowRight } from "../../../assets/svg/arrow_r.svg";

import styles from "./ActiveLearningGuidelineSidebar.module.scss";

export interface ActiveLearningGuidelineSidebarProps {
  materialId: string;
  lesson: IActiveLearningLesson | null;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

export const ActiveLearningGuidelineSidebar: React.FC<ActiveLearningGuidelineSidebarProps> = ({
  materialId,
  lesson,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  const onShareMaterial = () =>
    lesson &&
    window.open(
      `${prefixPath}${activeLearningProjectionPath}/${materialId}?lesson=${lesson.id}`,
      "_blank",
    );

  const prevLesson = () => prevLessonId && onChangeLesson(prevLessonId);
  const nextLesson = () => nextLessonId && onChangeLesson(nextLessonId);

  return (
    <div className={styles.container}>
      <ul className={styles.menuList}>
        <li>
          {lesson?.lesson_no !== undefined && lesson?.lesson_no !== 0 && (
            <button onClick={onShareMaterial}>
              <ProjectorIcon className={styles.projector} />
              投影画面
            </button>
          )}
        </li>
        <li>
          <button onClick={prevLesson} disabled={!prevLessonId}>
            <ArrowLeft className={styles.arrow} />
            前の教材
          </button>
          <button onClick={nextLesson} disabled={!nextLessonId}>
            <ArrowRight className={styles.arrow} />
            次の教材
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ActiveLearningGuidelineSidebar;
